import script from "./inputPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./inputPhone.vue?vue&type=script&setup=true&lang=js"

import "./inputPhone.vue?vue&type=style&index=0&id=2f308b7e&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f308b7e"]])

export default __exports__